<template>
  <sweet-modal
    ref="modal"
    class="vld-parent"
    hide-close-button
    @close="closeModalCleanUp"
  >
    <div style="margin-bottom: 2em">
      <p v-if="editRowExternalDialog">
        {{ $t('saved_rows.container_subtitle_edit') }}
      </p>
      <p v-else>{{ $t('saved_rows.container_subtitle') }}</p>
    </div>
    <template #title>
      <strong v-if="editRowExternalDialog" id="modal-title">{{
        $t('saved_rows.container_title_edit')
      }}</strong>
      <strong v-else id="modal-title">{{
        $t('saved_rows.container_title')
      }}</strong>
    </template>
    <save-row-form
      ref="form"
      @row-saved="closeModalCleanUp"
      @new-category="reloadCategories"
    />
  </sweet-modal>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue-3';
import {mapState, mapActions, mapMutations} from 'vuex';
import SaveRowForm from '@/components/rows/SaveRowForm.vue';

export default {
  name: 'SaveRowModal',
  components: {
    SweetModal,
    SaveRowForm
  },
  computed: {
    ...mapState({
      saveRowOpen: state => state.saveRowOpen,
      saveRowPromise: state => state.saveRowPromise,
      editRowExternalDialog: state => state.editRowExternalDialog,
      rowCategories: state => state.rowCategoriesModule.rowCategories
    })
  },
  methods: {
    ...mapActions(['resetExternalContentUrls']),
    ...mapMutations(['setSaveRowOpen', 'setSaveRowData']),
    closeModalCleanUp() {
      this.saveRowPromise?.reject();
      this.setSaveRowOpen(false);
      this.setSaveRowData(undefined);
      if (this.$refs.form?.resetForm) {
        this.$refs.form.resetForm();
      }
    },
    reloadCategories() {
      this.resetExternalContentUrls({categories: this.rowCategories});
    }
  },
  watch: {
    saveRowOpen(newValue) {
      if (newValue === true) {
        this.$refs.modal.open();
      } else {
        this.$refs.modal.close();
      }
    }
  }
};
</script>

<style scoped>
#modal-title {
  text-align: center;
}

::v-deep .sweet-modal {
  overflow: visible !important;
}

::v-deep .sweet-title {
  padding-right: 32px !important;
  padding-left: 32px !important;
}
</style>
